export default function AboutSection() {
  const stats = [
    { value: '15+', label: 'Yıl Deneyim' },
    { value: '2.000+', label: 'Seans' },
    { value: '500+', label: 'Aile' },
    { value: '%97', label: 'Memnuniyet' },
  ];
  const certs = [
    'Hacettepe Üniversitesi – Psikoloji (Lisans)',
    'İstanbul Üniversitesi – Aile Danışmanlığı (Yüksek Lisans)',
    'EMDR Türkiye – Travma Terapisi Sertifikası',
    'Gottman Institute – Çift Terapisi Sertifikası',
    'Türk Psikologlar Derneği Üyesi',
  ];
  return (
    <section id="hakkinda" className="py-20 md:py-28 bg-cream">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 md:gap-20 items-center">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-2/3 h-2/3 bg-gold-pale rounded-2xl -z-10" />
            <div className="relative rounded-2xl overflow-hidden h-[480px] md:h-[560px]">
              <img
                src="https://storage.readdy-site.link/project_files/48992e90-baf8-4202-b6dc-8d2a52120724/56383216-8373-4bbe-bbd7-0db3e7373608_rek2.png?v=6018137f75ec0ddc9cf02e3c895ee533"
                alt="Uzm. Ayşegül Sert Hakkında"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 bg-white rounded-2xl p-5 border border-cream-deeper max-w-xs">
              <p className="font-serif text-warm-dark text-base italic leading-snug">
                "Empati, güven ve bilimsel yaklaşım — her seansımın temel taşları."
              </p>
              <p className="text-xs text-warm-light mt-2">— Uzm. Ayşegül Sert</p>
            </div>
          </div>
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-3 block">Hakkımda</span>
            <h2 className="font-serif text-3xl md:text-4xl font-light text-warm-dark mb-5 leading-snug">
              Yanınızda olmak için<br /><em className="italic text-gold">buradayım</em>
            </h2>
            <p className="text-warm-mid text-sm md:text-base leading-relaxed mb-5">
              15 yılı aşkın deneyimimle aileler, çiftler ve bireylerle çalışıyorum. Her danışma sürecinde yargılamadan, tamamen sizin için orada olmayı ilke edindim.
            </p>
            <p className="text-warm-mid text-sm leading-relaxed mb-8">
              Terapötik yaklaşımımın merkezinde <strong className="text-warm-dark">empati, güven ve bilimsel yöntemler</strong> yer alır. Bilişsel Davranışçı Terapi, EMDR ve Gottman yöntemlerini bütüncül bir yaklaşımla uyguluyorum.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10">
              {stats.map((s) => (
                <div key={s.value} className="text-center bg-white rounded-xl p-4 border border-cream-deeper">
                  <p className="font-serif text-2xl font-semibold text-gold">{s.value}</p>
                  <p className="text-xs text-warm-light mt-1">{s.label}</p>
                </div>
              ))}
            </div>
            <div className="bg-white rounded-xl p-6 border border-cream-deeper">
              <p className="text-xs font-semibold text-warm-mid uppercase tracking-wider mb-4">Eğitim & Sertifikalar</p>
              <ul className="flex flex-col gap-2.5">
                {certs.map((c) => (
                  <li key={c} className="flex items-start gap-2.5 text-sm text-warm-mid">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"><i className="ri-medal-line text-gold text-sm" /></span>
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}